export const LOCAL_STORAGE_KEYS = {
	WALLET_DERIVATION_PATH: 'derivationPath',
	APP_BANNER_DISMISSED: 'appBannerDismissed',
};
